import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

// 权限管理一级
const permissionRouter: RouteConfig = {
  path: '/permission',
  component: Layout,
  redirect: '/permission/permission-account',
  meta: {
    title: '权限',
    icon: 'menu-permission'
  },
  children: [
    {
      name: 'PermissionAccount',
      path: 'permission-account',
      component: () => import('@/views/permission/permission-account/index.vue'),
      meta: {
        title: '账号权限列表',
        showTitle: true
      }
    },
    {
      name: 'PermissionRole',
      path: 'permission-role',
      component: () => import('@/views/permission/permission-role/index.vue'),
      meta: {
        title: '角色权限列表',
        showTitle: true
      }
    },
    {
      name: 'PermissionManage',
      path: 'permission-manage',
      component: () => import('@/views/permission/permission-manage/index.vue'),
      meta: {
        title: '权限管理列表',
        showTitle: true
      }
    }
  ]
}

export default permissionRouter
